module.exports = __webpack_public_path__ + "img/Button_KreditPro.50afaf59.png";